import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCheapestRate = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableCheapestRate);
};
